import 'chosen';
import queryString from 'query-string';

const $chsnSelect = $('.ch-select');
if ($chsnSelect.length > 0) {
  $chsnSelect.chosen();
}

const ACTIVE = 'is-active';
const FOOTER_ZINDEX = 'lower-index';
let blogFormHolderHeight;

function BindEvents() {
  const $blogForm = $('.js-blogger-form');
  const $blogFormHolder = $('.js-form-holder');
  const $blogFormBtn = $('.js-blogger-form-btn');
  const $blogFormClose = $('.js-blogger-form-close');
  const $voteButton = $('.js-project-vote');
  const $projectFilter = $('.js-blogger-project-filter');
  const $projectSelection = $('.js-select-project');
  const $footer = $('footer');

  if (matchMedia('(min-width: 768px)').matches) {
    blogFormHolderHeight = $blogFormHolder.outerHeight(true);
    if ($('.js-cookie-consent').css('display') !== 'none') {
      blogFormHolderHeight -= $('.js-cookie-consent').outerHeight(true);
    }
    $blogForm.css({
      bottom: -blogFormHolderHeight,
    });
  }

  $blogFormBtn.click(() => {
    $blogForm.addClass(ACTIVE);
    $footer.addClass(FOOTER_ZINDEX);
  });

  $blogFormClose.click(() => {
    $blogForm.removeClass(ACTIVE);
    $footer.removeClass(FOOTER_ZINDEX);
  });

  $voteButton.click(e => {
    e.preventDefault();

    $blogForm.addClass(ACTIVE);
    $footer.addClass(FOOTER_ZINDEX);

    const submissionId = e.currentTarget.getAttribute('data-submission');
    $projectSelection.val(submissionId);
  });

  $projectFilter.change(e => {
    const selectedValue = e.currentTarget.value;
    if (selectedValue === '') {
      return;
    }

    scrollToProject(selectedValue);
  });

  $(window).resize(() => {
    if (matchMedia('(min-width: 768px)').matches) {
      blogFormHolderHeight = $blogFormHolder.outerHeight(true);
      if ($('.js-cookie-consent').css('display') !== 'none') {
        blogFormHolderHeight -= $('.js-cookie-consent').outerHeight(true);
      }
      $blogForm.css({
        bottom: -blogFormHolderHeight,
      });
    }
  });

  $('.js-cookies-allow').click(() => {
    if (matchMedia('(min-width: 768px)').matches) {
      blogFormHolderHeight = $blogFormHolder.outerHeight(true);
      $blogForm.css({
        bottom: -blogFormHolderHeight,
      });
    }
  });

  if ($('.js-form-confirmation').length) {
    /* Tracking code goodness. */
    fbq('track', 'CompleteRegistration'); // eslint-disable-line no-undef
    goog_report_conversion(); // eslint-disable-line no-undef
    setTimeout(() => {
      $blogForm.removeClass(ACTIVE);
    }, 5000);
  }
}

if ($('.js-blogger-form').length > 0) {
  window.addEventListener('load', BindEvents);
  Sys.WebForms.PageRequestManager.getInstance().add_endRequest(BindEvents);
}

$(window).load(() => {
  const parsed = queryString.parse(location.search);
  if (parsed.project) {
    scrollToProject(parsed.project);
  }
});

function scrollToProject(projectId) {
  const $scrollToElement = $(`[data-scrollto=${projectId}]`);
  if ($scrollToElement) {
    $('html, body').animate(
      {
        scrollTop: $scrollToElement.offset().top,
      },
      500,
    );
  }
}
